import { Icon } from '../../Elements'
import React, { useEffect, useState } from 'react'
import Debounce from '../../Elements/Textboxs/Debounce'

const GoTopPage = () => {
  const [show, setShow] = useState<boolean>(false)
  useEffect(() => {
    window.document.body.addEventListener('scroll', (e: any) => {
      if (e.currentTarget.scrollTop > 600)
        Debounce({
          func() {
            setShow(true)
          },
          timeout: 200,
        })
      else
        Debounce({
          func() {
            setShow(false)
          },
          timeout: 200,
        })
    })
  }, [])
  return (
    <Icon
      icon='rayteb-arrow-up-b'
      onClick={() => {
        window.document.body.scroll({ top: 0, behavior: 'smooth' })
      }}
      className={`h-12 w-12 bg-secondary/40 backdrop-blur-sm rounded-full fixed right-7  bottom-6 
      transition-all duration-150 ${
        !show ? 'translate-y-[200%]' : 'translate-y-0 '
      }`}
    />
  )
}

export default React.memo(GoTopPage)
